
<div class="Pricing">
    <div class="Price-Wrap">
        <!-- Lite Plan -->
        <Card
            class="Price-Card Price-Card--lite"
            :class="{ 'current-plan': planType === 'lite' }"
        >
            <div class="PlanLabel">
                <i class="ri-flashlight-line"></i>
                <span>Lite</span>
            </div>
            <div class="PlanDescription">TSE-konform und rechtssicher starten</div>
            <h3 class="PlanPrice">
                <div>10,00€</div>
            </h3>
            <div class="PriceInfo">pro Monat / pro Fahrzeug</div>
            <ul class="FeatureList">
                <li>
                    <span class="FeatureIconCircle"><i class="ri-database-2-line"></i></span>
                    <span>Datenspeicherung in Echtzeit</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-sim-card-line"></i></span>
                    <span>SIM-Karte inklusive</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"
                        ><i class="ri-shield-keyhole-line"></i
                    ></span>
                    <span>TSE Gateway Gebühren inklusive</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-team-line"></i></span>
                    <span>Mitarbeiterverwaltung</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"
                        ><i class="ri-calendar-check-line"></i
                    ></span>
                    <span>Schichtmanagement</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-file-edit-line"></i></span>
                    <span>Manuelle TSE Kassenmeldung ans Finanzamt</span>
                </li>
            </ul>
            <div class="PlanCta">
                <Button
                    v-if="planType === 'lite'"
                    variant="outline"
                    disabled
                    class="Upgrade-Button"
                >
                    Aktueller Tarif
                </Button>
                <Button
                    v-else
                    variant="outline"
                    class="Upgrade-Button"
                    @onClick="handleUpgrade('lite')"
                >
                    {{ getButtonText('lite') }}
                </Button>
            </div>
        </Card>

        <!-- Basic Plan -->
        <Card
            class="Price-Card Price-Card--highlight Price-Card--premium"
            :class="{ 'current-plan': planType === 'basic' }"
        >
            <div
                class="PopularBadge"
                v-tooltip="'98% unserer Kunden entscheiden sich für den Basic Tarif'"
            >
                <i class="ri-fire-fill"></i>
                <span>Bestseller</span>
            </div>
            <div class="PlanLabel">
                <i class="ri-medal-line"></i>
                <span>Basic</span>
            </div>
            <div class="PlanDescription">Die bewährte Lösung für wachsende Flotten</div>
            <h3 class="PlanPrice">
                <div>16,00€</div>
            </h3>
            <div class="PriceInfo">pro Monat / pro Fahrzeug</div>
            <ul class="FeatureList">
                <li class="FeatureHighlight">
                    <span class="FeatureIconCircle"
                        ><i class="ri-checkbox-circle-line"></i
                    ></span>
                    <span><strong>Alles in Lite</strong></span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-magic-line"></i></span>
                    <span><strong>Automatische TSE Kassenmeldung ans Finanzamt</strong></span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-file-list-3-line"></i></span>
                    <span>Betriebsnachweise</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-time-line"></i></span>
                    <span>Arbeitszeitnachweise</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-bar-chart-line"></i></span>
                    <span>Analyse & Reporting</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-alarm-line"></i></span>
                    <span>
                        Erinnerungen
                        <span class="FeatureSubtext">Für TÜV, P-Schein, Eichung etc</span>
                    </span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-smartphone-line"></i></span>
                    <span>
                        Driver App
                        <span class="FeatureSubtext"
                            >Pausenverwaltung, Fahrtmarkierungen, Umsatz-Tracking, MyPOS
                            Integration</span
                        >
                    </span>
                </li>
            </ul>
            <MenuDropdown
                title="Ihr Sparpotenzial prüfen"
                :items="basicDiscountItems"
                :open-upward="true"
                class="theme-dark"
            >
                <template #tooltip="{ item }">
                    <span>{{ item.tooltip }}</span>
                </template>
            </MenuDropdown>
            <div class="PlanCta">
                <Button
                    v-if="planType === 'basic'"
                    variant="outline"
                    disabled
                    class="Upgrade-Button"
                >
                    Aktueller Tarif
                </Button>
                <Button
                    v-else
                    class="Upgrade-Button Upgrade-Button--primary"
                    @onClick="handleUpgrade('basic')"
                >
                    {{ getButtonText('basic') }}
                </Button>
            </div>
        </Card>

        <!-- Premium Plan -->
        <Card
            v-if="false"
            class="Price-Card Price-Card--premium"
            :class="{ 'current-plan': planType === 'premium' }"
        >
            <div class="PlanLabel">
                <i class="ri-vip-crown-line"></i>
                <span>Premium</span>
            </div>
            <div class="PlanDescription">
                Vollständige Lösung für professionelle Fahrzeugunternehmen
            </div>
            <h3 class="PlanPrice">
                <div>29,00€</div>
            </h3>
            <div class="PriceInfo">pro Monat / pro Fahrzeug</div>
            <ul class="FeatureList">
                <li class="FeatureHighlight">
                    <span class="FeatureIconCircle"
                        ><i class="ri-checkbox-circle-line"></i
                    ></span>
                    <span><strong>Alles in Basic</strong></span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-timeline-view"></i></span>
                    <span>Schichtplanner</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-links-line"></i></span>
                    <span>
                        Automatische Fahrtzuordnung
                        <span class="FeatureSubtext">Bolt, Uber, FreeNow</span>
                    </span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-calculator-line"></i></span>
                    <span>Rücklagenrechner</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"
                        ><i class="ri-calendar-event-line"></i
                    ></span>
                    <span>Kalender</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-tools-line"></i></span>
                    <span>Fahrzeugwartung</span>
                </li>
                <li>
                    <span class="FeatureIconCircle"><i class="ri-book-open-line"></i></span>
                    <span>Kassenbuch</span>
                </li>
            </ul>
            <MenuDropdown
                title="Rabatte anzeigen"
                :items="premiumDiscountItems"
                :open-upward="true"
                class="theme-dark"
            >
                <template #tooltip="{ item }">
                    <span>{{ item.tooltip }}</span>
                </template>
            </MenuDropdown>
            <div class="PlanCta">
                <Button
                    v-if="planType === 'premium'"
                    variant="outline"
                    disabled
                    class="Upgrade-Button"
                >
                    Aktueller Plan
                </Button>
                <Button
                    v-else
                    class="Upgrade-Button Upgrade-Button--premium"
                    @onClick="handleUpgrade('premium')"
                >
                    {{ getButtonText('premium') }}
                </Button>
            </div>
        </Card>
    </div>
</div>
